import React from 'react';
import { Typography, Card, Divider, Table } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const CookiesPage = () => {
  const cookieColumns = [
    {
      title: 'Ονομασία',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Προέλευση',
      dataIndex: 'origin',
      key: 'origin',
    },
    {
      title: 'Είδος',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Διάρκεια',
      dataIndex: 'duration',
      key: 'duration',
    },
  ];

  const cookieData = [
    {
      key: '1',
      name: '_ga',
      origin: '3rd-party cookies',
      type: 'Cookies απόδοσης',
      duration: '2 χρόνια',
    },
    {
      key: '2',
      name: '_ga_<container-id>',
      origin: '3rd-party cookies',
      type: 'Cookies απόδοσης',
      duration: '2 χρόνια',
    },
  ];

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <SettingOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ marginTop: 16 }}>
            Πολιτική Cookies
          </Title>
          <Text type="secondary">Τελευταία ενημέρωση: 30/04/2026</Text>
        </div>

        <Title level={4}>ΤΙ ΕΙΝΑΙ ΤΑ COOKIES</Title>
        <Paragraph>
          Η ιστοσελίδα animap.gr και η σχετική διαδικτυακή πλατφόρμα της animap (εφεξής συνολικά η «Ιστοσελίδα») συγκεντρώνει στοιχεία αναγνώρισης των επισκεπτών/χρηστών της χρησιμοποιώντας cookies. Τα cookies είναι μικρά αρχεία κειμένου που αποθηκεύονται στο σκληρό δίσκο κάθε επισκέπτη/χρήστη και δεν λαμβάνουν γνώση οποιουδήποτε εγγράφου ή αρχείου από τον υπολογιστή του.
        </Paragraph>
        <Paragraph>
          Χρησιμοποιούνται για την διευκόλυνση πρόσβασης του επισκέπτη/χρήστη όσον αφορά στη χρησιμοποίηση συγκεκριμένων υπηρεσιών της Ιστοσελίδας, για στατιστικούς λόγους και σκοπούς ανάλυσης της χρήσης της Ιστοσελίδας, όπως π.χ. προκειμένου να εντοπίζονται οι επιμέρους σελίδες της Ιστοσελίδας οι οποίες είναι περισσότερο χρήσιμες ή δημοφιλείς.
        </Paragraph>
        <Paragraph>
          Τα στοιχεία αυτά μπορεί να περιλαμβάνουν επίσης τον τύπο του φυλλομετρητή (browser) που χρησιμοποιεί ο επισκέπτης/χρήστης, το είδος του υπολογιστή, το λειτουργικό του σύστημα, τους παρόχους διαδικτυακών υπηρεσιών και λοιπές πληροφορίες τέτοιου είδους.
        </Paragraph>
        <Paragraph>
          Ο επισκέπτης/χρήστης της ιστοσελίδας μπορεί να ρυθμίσει το πρόγραμμα του για πλοήγηση στο διαδίκτυο (web browser) κατά τέτοιο τρόπο ώστε, είτε να τον προειδοποιεί για τη χρήση των cookies σε συγκεκριμένες υπηρεσίες, είτε να μην επιτρέπει την αποδοχή της χρήσης cookies σε καμία περίπτωση.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΙΔΗ COOKIES</Title>
        <Paragraph>
          Χρησιμοποιούμε τα παρακάτω είδη cookies στην Ιστοσελίδα:
        </Paragraph>

        <Paragraph>
          <Text strong>Cookies απόδοσης:</Text> Τα cookies απόδοσης συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι επισκέπτες/χρήστες χρησιμοποιούν την Ιστοσελίδα, για παράδειγμα, ποιες σελίδες επισκέπτονται συχνότερα και αν λαμβάνουν μηνύματα σφαλμάτων πρόσβασης ή/και χρήσης της Ιστοσελίδας. Επίσης, συλλέγουν συγκεντρωτικές, ανώνυμες πληροφορίες που δεν ταυτοποιούν κάποιον επισκέπτη/χρήστη. Τα cookies αυτά χρησιμοποιούνται αποκλειστικά για τη βελτίωση των επιδόσεων της Ιστοσελίδας και η χρήση τους βασίζεται στο έννομο συμφέρον μας.
        </Paragraph>

        <Paragraph>
          <Text strong>Cookies λειτουργικότητας/απαραίτητα:</Text> Τα cookies λειτουργικότητας χρησιμοποιούνται για την παροχή υπηρεσιών μας. Οι πληροφορίες που συλλέγουν τα cookies αυτά μπορεί να γίνουν ανώνυμες και δεν είναι δυνατόν να παρακολουθήσουν την δραστηριότητα της περιήγησης σε άλλους ιστοτόπους. Αν δεν δεχθείτε αυτά τα cookies, μπορεί να επηρεαστεί η απόδοση και λειτουργικότητα της Ιστοσελίδας ή/και να περιοριστεί η πρόσβασή σας σε αυτήν.
        </Paragraph>

        <Paragraph>
          <Text strong>Cookies στόχευσης/διαφήμισης:</Text> Χρησιμοποιούνται για την παροχή περιεχομένου, που ταιριάζει περισσότερο σε εσάς και τα ενδιαφέροντά σας. Μπορεί να χρησιμοποιηθούν για την αποστολή στοχευμένης διαφήμισης, τον περιορισμό προβολών διαφήμισης ή την μέτρηση αποτελεσματικότητας μιας διαφημιστικής καμπάνιας.
        </Paragraph>

        <Divider />

        <Title level={4}>ΧΡΗΣΙΜΟΠΟΙΟΥΜΕΝΑ COOKIES</Title>
        <Paragraph>
          Συγκεκριμένα, στην Ιστοσελίδα χρησιμοποιούμε τα παρακάτω cookies:
        </Paragraph>
        <Table
          columns={cookieColumns}
          dataSource={cookieData}
          pagination={false}
          bordered
          size="small"
        />

        <Divider />

        <Title level={4}>ΑΠΕΝΕΡΓΟΠΟΙΗΣΗ COOKIES</Title>
        <Paragraph>
          Σε περίπτωση που δεν συμφωνείτε με την αποθήκευση των πληροφοριών που συλλέγονται από τα cookies, κάθε φυλλομετρητής ιστοσελίδων (web browser) παρέχει σαφείς οδηγίες σχετικά με την απενεργοποίησή τους.
        </Paragraph>
        <Paragraph>
          Οι περισσότερες υπηρεσίες της Ιστοσελίδας λειτουργούν χωρίς τη χρήση cookies. Ως εκ τούτου, εάν απενεργοποιήσετε τα cookies, ενδέχεται να επηρεαστεί η εκ μέρους σας χρήση της Ιστοσελίδας ή να μην έχετε πρόσβαση σε ορισμένες υπηρεσίες και χαρακτηριστικά της Ιστοσελίδας.
        </Paragraph>
        <Paragraph>
          Ακολούθως παρατίθενται παραπομπές των βασικότερων web browser:
        </Paragraph>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.microsoft.com/en-us/office/enable-cookies-6b018d22-1d24-43d9-8543-3d35ddb2cb52" target="_blank" rel="noopener noreferrer">Internet Explorer</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/en-is/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        </ul>

        <Divider />

        <Title level={4}>ΤΡΟΠΟΠΟΙΗΣΕΙΣ</Title>
        <Paragraph>
          Διατηρούμε το δικαίωμα να αναθεωρήσουμε την παρούσα πολιτική ανά πάσα στιγμή. Για το λόγο αυτό, σας καλούμε να επισκέπτεστε περιοδικά την παρούσα σελίδα προκειμένου να παραμένετε ενημερωμένοι. Η ημερομηνία κατά την οποία η παρούσα πολιτική αναθεωρήθηκε τελευταία φορά βρίσκεται στην κορυφή αυτής της σελίδας.
        </Paragraph>
        <Paragraph>
          Για περισσότερες πληροφορίες για την προστασία της ιδιωτικότητάς σας, σας παραπέμπουμε επίσης στην <Link to="/privacy">Δήλωση Προστασίας Προσωπικών Δεδομένων</Link> της animap.
        </Paragraph>

        <Divider />

        <Paragraph type="secondary" style={{ textAlign: 'center' }}>
          Δείτε επίσης: <Link to="/terms">Όροι Χρήσης</Link> | <Link to="/privacy">Πολιτική Απορρήτου</Link>
        </Paragraph>
      </Card>
    </div>
  );
};

export default CookiesPage;
